import { DefaultService as DomainsSDK } from '@atbay/domains-manager-node-sdk'
import { createClient } from '@core/base/http-client'

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const DomainsClient = createClient(DomainsSDK)
